import React, { useRef, useEffect, useState } from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    collapseContainer: {
        overflow: 'hidden',
        transition: 'height 0.3s ease',
    },
    innerContainer: {
        overflow: 'hidden',
    },
});

interface CollapseProps {
    in: boolean;
    children: React.ReactNode;
}

const Collapse: React.FC<CollapseProps> = ({ in: inProp, children }) => {
    const classes = useStyles();
    const [height, setHeight] = useState('0px');
    const innerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (inProp) {
            setHeight(`${innerRef.current?.scrollHeight}px`);
        } else {
            setHeight('0px');
        }
    }, [inProp]);

    return (
        <div className={classes.collapseContainer} style={{ height }}>
            <div ref={innerRef} className={classes.innerContainer}>
                {children}
            </div>
        </div>
    );
};

export default Collapse;
